import { render } from "./FlappyBirdComponent.vue?vue&type=template&id=85441014&scoped=true"
import script from "./FlappyBirdComponent.vue?vue&type=script&lang=js"
export * from "./FlappyBirdComponent.vue?vue&type=script&lang=js"

import "./FlappyBirdComponent.vue?vue&type=style&index=0&id=85441014&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85441014"]])

export default __exports__